// extracted by extract-css-chunks-webpack-plugin
module.exports = {"publish-btn":"publish-button__publish-btn___2j3_O","publishBtn":"publish-button__publish-btn___2j3_O","waiting":"publish-button__waiting___T2T-X"};
    if(module.hot) {
      // 1743106938881
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  